import { combineReducers } from 'redux';
import { createAsyncReducer } from 'redux-easy-async';
import productShoppingActions from "./product_shopping_actions";
import profiles from "./profiles";
import { updateVisitorProfile, readVisitorProfile, readVisitorProductShoppingActions } from "../../actions";
export default combineReducers({
  profiles: profiles,
  productShoppingActions: productShoppingActions,
  requests: createAsyncReducer([updateVisitorProfile, readVisitorProfile, readVisitorProductShoppingActions])
});